/**
 * Displays Regular skeleton (if requested) for 5 seconds (if not already loaded)
 */
module.exports = class {
    onCreate(input) {
        this.state = {
            skeletonId: `skeleton${input.placementId}`,
        };
    }
    onMount() {
        const { skeletonId } = this.state;
        document.getElementById(skeletonId).style.display = 'block';
        setTimeout(() => {
            document.getElementById(skeletonId).style.display = 'none';
        }, 5000);
    }
};
